module.exports = __webpack_public_path__ + "static/novel-logo-80de490baaff9f0d7f25fd96d385a075.png";